import {
  Card,
  CardHeader,

  CardContent,
  ButtonGroup,
  Typography,
  Grid2,
} from "@mui/material";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import { useEffect, useState } from "react";
import { useLoading } from "../../../../context/LodingContext";
import request from "graphql-request";
import BASEURL from "../../../../pages/Utils/Baseurl";
import { useLocation } from "react-router-dom";
import { getDeliveryById } from "../graphQl";
import {  PDFDownloadLink} from "@react-pdf/renderer";
import DeliveryPDF from "./DeliveryPdf";
import MaterialButton from "../../../../components/MaterialButton";
import { Download, WhatsApp } from "@mui/icons-material";
import { StyleSheet } from "@react-pdf/renderer";
import PDFURL from "../../../../pages/Utils/pdfurl";

const PdfPage = () => {
  const location = useLocation();
  const rowId = location?.state?.rowId;
  const {  setCirleLoading } = useLoading();
  const [deliveryData, setDeliveryData] = useState(null);
  const [pdfUrl, setPdfUrl] = useState("");

  const styles = StyleSheet.create({
    page: {
      padding: 30,
      fontSize: 11,
      lineHeight: 1.5,
    },
    section: {
      marginBottom: 12,
    },
    label: {
      fontWeight: "bold",
    },
    tableHeader: {
      flexDirection: "row",
      borderBottom: 1,
      marginBottom: 4,
      paddingBottom: 2,
    },
    row: {
      flexDirection: "row",
      borderBottom: "1px solid #eee",
      paddingVertical: 4,
    },
    col: {
      width: "33%",
    },
  });
  //Fetch table data by ID
  useEffect(() => {
    if (!rowId) return;

    const fetchDeliveryDataById = async () => {
      try {
        setCirleLoading(true);
        const response = await request(BASEURL, getDeliveryById, {
          id: rowId,
        });
        const responseData = await response?.getDeliveryById?.data[0];
        const success = await response?.getDeliveryById?.success;
    
       
        if (success) {
          setDeliveryData(responseData);
          setPdfUrl(PDFURL + response?.getDeliveryById?.pdfUrl)
        } else {
          setDeliveryData(null);
        }
      } catch (error) {
        console.error("Error fetching data", error);
      } finally {
        setCirleLoading(false);
      }
    };

    fetchDeliveryDataById();
  }, [rowId]);

  //Share through Whatsapp
  const handleWhatsapp = () => {
    const phoneNumber = deliveryData?.contactNumber; // Replace with the target phone number
    const message = encodeURIComponent(
      `Dear ${deliveryData?.customerName},
              Here is your Reciept for your purchase.

              Thank You for your co-operation.
              `
    ); // Optional message
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

    // Open WhatsApp URL in a new tab
    window.open(whatsappUrl, "_blank");
  };

  const handleDownloadPDF = async () => {
    if (!pdfUrl) return;

    try {
      const response = await fetch(pdfUrl);
      if (!response.ok) throw new Error("Failed to download PDF");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `${deliveryData?.deliveryId || "Delivery"}_Delivery.pdf`;

      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("PDF download failed:", error);
    }
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title="Delivery Receipt "
          action={
            deliveryData && (
              <>
                <ButtonGroup
                  variant="outlined"
                  aria-label="Loading button group"
                >
                 <MaterialButton
  color="dark"
  variant="gradient"
  onClick={handleDownloadPDF}
  disabled={!pdfUrl}
>
  <Download /> PDF
</MaterialButton>
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    onClick={handleWhatsapp}
                  >
                    <WhatsApp /> Share
                  </MaterialButton>
                </ButtonGroup>
              </>
            )
          }
        />
        <CardContent>
          {deliveryData && (
            <>
              <Grid2 container spacing={2}>
                <Grid2 size={{ xs: 6 }}>
                  <Typography variant="body2" gutterBottom>
                    <span style={{ fontWeight: 600 }}>Delivery ID:</span>{" "}
                    {deliveryData?.deliveryId || "N/A"}
                  </Typography>
                </Grid2>
                <Grid2 size={{ xs: 6 }}>
                  <Typography variant="body2">
                    <span style={{ fontWeight: 600 }}>Delivered Date:</span>{" "}
                    {deliveryData?.deliveredDate || "N/A"}
                  </Typography>
                </Grid2>
                <Grid2 size={{ xs: 6 }}>
                  <Typography variant="body2">
                    <span style={{ fontWeight: 600 }}>Customer:</span>{" "}
                    {deliveryData?.customerName || "N/A"}
                  </Typography>
                </Grid2>
                <Grid2 size={{ xs: 6 }}>
                  <Typography variant="body2">
                    <span style={{ fontWeight: 600 }}>Address:</span>{" "}
                    {deliveryData?.customerAddress || "N/A"}
                  </Typography>
                </Grid2>
                <Grid2 size={{ xs: 6 }}>
                  <Typography variant="body2">
                    <span style={{ fontWeight: 600 }}>Contact Person:</span>{" "}
                    {deliveryData?.contactPerson || "N/A"}
                  </Typography>
                </Grid2>
                <Grid2 size={{ xs: 6 }}>
                  <Typography variant="body2">
                    <span style={{ fontWeight: 600 }}>Contact Number:</span>{" "}
                    {deliveryData?.contactNumber || "N/A"}
                  </Typography>
                </Grid2>
                <Grid2 size={{ xs: 6 }}>
                  <Typography variant="body2">
                    <span style={{ fontWeight: 600 }}>Sales Order:</span>{" "}
                    {deliveryData?.salesOrder?.soNumber || "N/A"}
                  </Typography>
                </Grid2>
                <Grid2 size={{ xs: 6 }}>
                  <Typography variant="body2">
                    <span style={{ fontWeight: 600 }}>
                      Delivery Representative:
                    </span>{" "}
                    {deliveryData?.repName || "N/A"}
                  </Typography>
                </Grid2>
                <Grid2 size={{ xs: 12 }}>
                  <Typography variant="body2">
                    <span style={{ fontWeight: 600 }}>Payment Mode:</span>{" "}
                    {deliveryData?.paymentMode || "N/A"}
                  </Typography>
                </Grid2>
              </Grid2>

              <Typography variant="body2" sx={{ mt: 2 }}>
                <span style={{ fontWeight: 600 }}>Products:</span>
              </Typography>
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  marginTop: 10,
                }}
              >
                <thead>
                  <tr style={{ backgroundColor: "#f0f0f0" }}>
                    <th
                      style={{
                        border: "1px solid #ccc",
                        padding: "6px",
                        fontSize: "15px",
                      }}
                    >
                      Product Code
                    </th>
                    <th
                      style={{
                        border: "1px solid #ccc",
                        padding: "6px",
                        fontSize: "15px",
                      }}
                    >
                      Product Name
                    </th>
                    <th
                      style={{
                        border: "1px solid #ccc",
                        padding: "6px",
                        fontSize: "15px",
                      }}
                    >
                      Quantity
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {deliveryData?.deliveryProducts?.map((prod, idx) => (
                    <tr key={idx}>
                      <td
                        style={{
                          border: "1px solid #ccc",
                          padding: "6px",
                          fontSize: "15px",
                        }}
                      >
                        {prod?.productCode || "N/A"}
                      </td>
                      <td
                        style={{
                          border: "1px solid #ccc",
                          padding: "6px",
                          fontSize: "15px",
                        }}
                      >
                        {prod?.productName || "N/A"}
                      </td>
                      <td
                        style={{
                          border: "1px solid #ccc",
                          padding: "6px",
                          fontSize: "15px",
                        }}
                      >
                        {prod?.quantity || "N/A"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}
        </CardContent>
      </Card>
    </DashboardLayout>
  );
};

export default PdfPage;
